import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Widget } from '../Widget';
import { ADMIN_NAVIGATION } from '../../../data/adminNavigation';
import { useGovernance } from '../../../contexts/GovernanceContext';
import { useTerminology } from '../../../hooks/useTerminology';

/** Ids from the navigation register, so an action cannot drift from its page. */
const PREFERRED = ['governance', 'design-variants', 'launch', 'support', 'audit', 'settings', 'users', 'health'];

/**
 * Quick actions are drawn from the same navigation register the sidebar uses,
 * filtered by the permissions this administrator actually holds. An action
 * nobody can perform is not rendered — and because the services check again,
 * hiding it is convenience rather than the control.
 */
export function QuickActionsWidget() {
  const {
    allows
  } = useGovernance();
  const {
    phrase
  } = useTerminology();
  const items = ADMIN_NAVIGATION.flatMap(group => group.items);
  const available = PREFERRED.map(id => items.find(item => item.id === id)).filter((item): item is NonNullable<typeof item> => Boolean(item)).filter(item => !item.permission || allows(item.permission).allowed).slice(0, 6);
  return <Widget title="Quick actions" description="Only what your roles permit, in the scope you hold them." state={available.length ? 'ready' : 'empty'} emptyTitle="No actions available to your roles" emptyDescription="Your assignments do not currently permit any of these. Ask an administrator who holds the relevant permission." data-id="element-496" data-mp="1dhoosf21cjwb">
      <ul className="grid gap-2 sm:grid-cols-2" data-id="element-497" data-mp="1wdeq00259c95">
        {available.map(item => {
        const Icon = item.icon;
        return <li key={item.id} data-id="element-498" data-mp="2p2vi0wluqr4u">
              <Link to={item.to} className="flex min-h-touch items-center gap-2.5 rounded-lg border border-line bg-canvas px-3 py-2.5 text-body-sm font-medium text-ink transition-colors duration-150 ease-out hover:border-line-strong hover:bg-surface" data-id="element-499" data-mp="2p2lpb19fa5vg">
                <Icon className="h-4 w-4 shrink-0 text-ink-muted" aria-hidden="true" data-id="element-500" data-mp="2yq7vgfx2419p" />
                <span className="min-w-0 flex-1 truncate" data-id="element-501" data-mp="2tqv7frug8o5j">{phrase(item.labelTemplate)}</span>
                <ArrowRightIcon className="h-4 w-4 shrink-0 text-ink-subtle" aria-hidden="true" data-id="element-502" data-mp="2osjw1coia5l7" />
              </Link>
            </li>;
      })}
      </ul>
    </Widget>;
}